import React, { useContext, useEffect, useState } from "react";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { CarritoContext } from "./ProcesoCompraLayout";
import { getStripePromise } from "../../../../utils/stripe";
import { postComprasCheckoutSession } from "../../../../services/Api/MarketPlace/Compras";
import { UserContext } from "../../../../services/user";
import {
  selectResumenCompraPrecioTotal,
  selectResumenCompraProductosRequest,
} from "../../../../../reducers/carrito/carritoSelector";
import { useSelector } from "react-redux";

const TarjetaPago = ({ datosEnvio }) => {


  const [clientSecret, setClientSecret] = useState("");
  const precioTotal = useSelector(selectResumenCompraPrecioTotal);
  const resumenCompra = useSelector(selectResumenCompraProductosRequest);
  const { user } = useContext(UserContext);


  const { informacionMetodoPago } = useContext(CarritoContext);


  useEffect(() => {
    let body = {
      usuario: {
        _id: user._id,
      },
      plantel: {
        _id: user.escuela.campus._id,
      },
      datosEnvio: {
        _id: datosEnvio._id,
      },
      factura: informacionMetodoPago.factura === "true",
      subTotal: precioTotal,
      total: precioTotal,
      carrito: resumenCompra,
      metodoDePago: "card",
    };

    postComprasCheckoutSession(body).then((response) => setClientSecret(response.clientSecret));
  }, []);


  return (
    <div className="flex flex-col gap-6">
      <div id="checkout">
        {clientSecret && (
          <EmbeddedCheckoutProvider stripe={getStripePromise()} options={{ clientSecret }}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        )}
      </div>
    </div>
  );
};

export default TarjetaPago;
